export default __webpack_public_path__ + "static/media/goblin5.aa160a13.jpg";